
import initialState from "./filter.value";

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case "Set_week_days":
      return {
        ...state,
        filter: {
          ...state.filter,
          weekDaySelected: action.payload.weekDaySelected,
        },
      };

      
      case "Set_Kpi_Data2":
        return {
          ...state,
          listKpis2: action.payload.listKpis2,
        };
    case "Set_Kpi_Data":
      return {
        ...state,
        filter: {
          ...state.filter,
          kpisSelected: action.payload.kpisSelected,
        },
      };
      //
      // set stores location
    case "Set_store_data":
      return {
        ...state,
        filter: {
          ...state.filter,
          selectedLocationStore: action.payload.selectedLocationStore,
        },
      };
      // set stores calender
    case "Set_calender_data":
      return {
        ...state,
        filter: {
          ...state.filter,
          selectedStart: action.payload.selectedStart,
          selectedEnd: action.payload.selectedEnd,
          compareStart: action.payload.compareStart,
          compareEnd: action.payload.compareEnd,
        },
      };
    default:
      return state;
  }
};

export default filterReducer;